import StorageManager from "@/features/storage";

export const useParticipantSession = () => {
  const token = StorageManager.getTokenData();
  return {
    participantId: token?.participantId ?? null,
    currency: token?.currency ?? null,
    countryCode: token?.countryCode ?? null,
  };
};
